import type { CSSProperties } from 'react';

/**
 * Токены дизайн-системы FISHKA HUB 2.0 для inline-стилей компонентов `ds/*`.
 *
 * В отличие от CRM (`frontend/src/components/ds/tokens.ts`, там hex), здесь
 * ВСЁ через CSS-переменные из `styles/global.css`: у вики есть тёмная тема
 * (`[data-theme="dark"]`), и hex в inline-стилях её бы сломал.
 * Радиусы — строго 4 / 6 / 8 (решение заказчика, _ds/colors_and_type.css).
 */
export const FK = {
  orange: 'var(--fk-orange)',
  orangeHover: 'var(--fk-orange-hover)',
  orangeSoft: 'var(--fk-orange-soft)',
  indigo: 'var(--fk-indigo)',
  blue: 'var(--fk-blue)',
  info: 'var(--fk-info)',
  success: 'var(--fk-success)',
  successText: 'var(--fk-success-text)',
  warning: 'var(--fk-warning)',
  warningText: 'var(--fk-warning-text)',
  error: 'var(--fk-error)',
  bg: 'var(--fk-bg)',
  bgSubtle: 'var(--fk-bg-subtle)',
  surface: 'var(--fk-surface)',
  text: 'var(--fk-text)',
  text2: 'var(--fk-text-2)',
  muted: 'var(--fk-text-muted)',
  border: 'var(--fk-border)',
  borderStrong: 'var(--fk-border-strong)',
  rowLine: 'var(--fk-row-line)',
  chartGrid: 'var(--fk-chart-grid)',
  chartCompare: 'var(--fk-chart-compare)',
  shadowCard: 'var(--fk-shadow-card)',
  shadowPop: 'var(--fk-shadow-pop)',
} as const;

/** Радиусы HUB 2.0: теги 4, кнопки/поля 6, карточки/чипы/бейджи 8. */
export const RADIUS = { sm: 4, md: 6, card: 8 } as const;

/** Категориальная палитра графиков (первая — флагманская серия, оранжевая). */
export const CHART_COLORS = [
  'var(--fk-chart-1)',
  'var(--fk-chart-2)',
  'var(--fk-chart-3)',
  'var(--fk-chart-4)',
  'var(--fk-chart-5)',
  'var(--fk-chart-6)',
  'var(--fk-chart-7)',
  'var(--fk-chart-8)',
] as const;

/** Белая карточка: 1px граница, радиус 8, мягкая индиго-тень. */
export const panel: CSSProperties = {
  background: FK.surface,
  border: `1px solid ${FK.border}`,
  borderRadius: RADIUS.card,
  boxShadow: FK.shadowCard,
};

/** Шрифт цифр и кодов (номера, ИНН, артикулы). */
export const MONO = "var(--fk-font-mono)";

/** Цвета тега `Tag`: [фон, текст, рамка]. */
export const TAG_COLORS = {
  default: ['var(--fk-neutral-soft)', 'var(--fk-text-2)', 'var(--fk-border)'],
  blue: ['var(--fk-blue-soft)', 'var(--fk-blue)', 'rgba(22,119,255,.35)'],
  orange: ['var(--fk-orange-soft)', 'var(--fk-orange)', 'rgba(255,105,0,.35)'],
  green: ['var(--fk-success-soft)', 'var(--fk-success-text)', 'rgba(124,179,66,.4)'],
  red: ['var(--fk-error-soft)', 'var(--fk-error)', 'rgba(229,57,53,.35)'],
  gold: ['var(--fk-warning-soft)', 'var(--fk-warning-text)', 'rgba(251,140,0,.4)'],
  indigo: ['rgba(37,29,74,.08)', 'var(--fk-indigo)', 'rgba(37,29,74,.25)'],
} as const;
export type TagColor = keyof typeof TAG_COLORS;

/** «1 234» — целое с пробелами-разрядами (ru-RU), для подписей и KPI. */
export function fmtInt(v: number): string {
  return Math.round(v).toLocaleString('ru-RU');
}

/** Русское множественное: plural(5, 'точка', 'точки', 'точек') → «точек». */
export function plural(n: number, one: string, few: string, many: string): string {
  const m10 = Math.abs(n) % 10;
  const m100 = Math.abs(n) % 100;
  if (m10 === 1 && m100 !== 11) return one;
  if (m10 >= 2 && m10 <= 4 && (m100 < 12 || m100 > 14)) return few;
  return many;
}
